import { render, staticRenderFns } from "./TypographyPage.vue?vue&type=template&id=d26d7a16&scoped=true&"
import script from "./TypographyPage.vue?vue&type=script&lang=js&"
export * from "./TypographyPage.vue?vue&type=script&lang=js&"
import style0 from "./TypographyPage.vue?vue&type=style&index=0&id=d26d7a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d26d7a16",
  null
  
)

export default component.exports